module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9IiM3ZWQzMjEiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTkuMDYzIDE3Ljk5OWEuOTk5Ljk5OSAwIDAgMS0uNzAzLS4yODhMMy4yOTcgMTIuNzFhLjk5OS45OTkgMCAxIDEgMS40MDYtMS40MjJsNC4zNTMgNC4yOTkgOS4yMzUtOS4yOTNhMSAxIDAgMCAxIDEuNDE4IDEuNDFsLTkuOTM3IDEwYTEuMDAxIDEuMDAxIDAgMCAxLS43MDkuMjk1Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/green-check.svg
// module id = XNdA
// module chunks = 0 2